import type { IconProps } from './icons.types';

/* Two `ChevronRightIcon` glyphs 5 apart, which is what widens the viewBox from 7 to 12. */
export function ChevronDoubleRightIcon({ size = 16 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 12 12" fill="currentColor" aria-hidden="true">
      <path d="M4.6 5.65375L0 1.05375L1.05375 0L6.7075 5.65375L1.05375 11.3075L0 10.2538L4.6 5.65375Z" />
      <path
        d="M4.6 5.65375L0 1.05375L1.05375 0L6.7075 5.65375L1.05375 11.3075L0 10.2538L4.6 5.65375Z"
        transform="translate(5 0)"
      />
    </svg>
  );
}
